import React, { useEffect, useState } from "react";
import { classifiedBanner, classified_banner } from "../../../assets/img";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import HomeIcon from "@mui/icons-material/Home";
import ClassifiedTab from "./ClassifiedTab";
import ClassifiedListBox from "./ClassifiedListBox";
import {
  useCategoryListsMutation,
  useOverallListMutation,
  useSubcategoriesMutation,
  useSubcategoryListMutation,
} from "../../../redux/api/api";
import {
  Link,
  useLocation,
  useNavigate,
  useSearchParams,
} from "react-router-dom";
const ClassifiedList = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams, setSearchParams] = useSearchParams();
  const [showTabList, setShowTabList] = useState(true);
  const [subCategTabList, setSubCategTabList] = useState(true);
  const [subcategoriesList, setSubCategoriesList] = useState([]);
  const [selectedSubCat, setSelectedSubCat] = useState();
  const [classifiedList, setClassifiedList] = useState([]);
  const [page, setPage] = useState(1);
  const [subcategoriesListId, setSubCategoriesListId] = useState("");
  const [subcategoriesListsId, setSubCategoriesListsId] = useState("");
  const [listOrder, setListOrder] = useState("");
  const [catNames, setCatNames] = useState({});
  const [catSubNames, setCatSubNames] = useState([]);

  const [subcategoriesData] = useSubcategoriesMutation();
  const [subcategoryListData] = useSubcategoryListMutation();
  const [overallList] = useOverallListMutation();
  const [catgoryList] = useCategoryListsMutation();

  useEffect(() => {
    window.scrollTo(0, 0);
    if (subcategoriesListsId) {
      getCategoryListWithPaginate(subcategoriesListsId);
    } else if (subcategoriesListId) {
      getSubcategoriesListPaginate(subcategoriesListId);
    } else if (!searchParams?.get("catId")) {
      getOverallList();
    }
  }, [page]);

  // OVER ALL FUNCTION
  const getOverallList = (order) => {
    removeQueryParams();
    if (Object.values(catNames)?.length > 0) {
      setPage(1);
    }
    setSubCategoriesListsId("");
    setSubCategoriesListId("");
    const formData = new FormData();
    formData.append("type", 1);
    if (order || listOrder !== "") {
      formData.append("order", order ? order : listOrder);
    } else {
      formData.append("order", "desc");
      setListOrder("desc");
    }

    let params = `?page=${page}`;

    overallList({ payload: formData, params })
      .unwrap()
      .then((res) => {
        if (res?.status === "success") {
          setClassifiedList(res);
          setSubCategTabList(true);
          setCatNames([]);
          setCatSubNames([]);
          setSelectedSubCat("");
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  // SUB CATEGORY FUNCTION
  const showTabListHandler = (item) => {
    setPage(1);
    const formData = new FormData();
    formData.append("subcategory_id", item?.id || item);
    subcategoriesData(formData)
      .unwrap()
      .then((res) => {
        if (res?.status === "success") {
          setSubCategoriesList(res?.sub_categories);
          if (searchParams?.get("subId")) {
            setSelectedSubCat(Number(searchParams?.get("subId")));
          }
          // else {
          //   setSelectedSubCat(res?.sub_categories?.[0]?.id);
          // }
          if (searchParams?.get("subId")) {
            getSubcategoriesList(searchParams?.get("subId"));
          } else {
            getCategoryList(item?.id);
            setSubCategoriesListsId(item?.id);
            // getSubcategoriesList(res?.sub_categories?.[0]?.id);
          }

          // setCatSubNames(res?.sub_categories[0]);
          // setSubCategoriesListId(res?.sub_categories?.[0]?.id);

          setSubCategTabList(false);
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  // CATEGORY LISTS
  const getCategoryList = (id) => {
    setSelectedSubCat("");
    let formdata = new FormData();
    formdata.append("type", 1);
    formdata.append("category_id", id);
    formdata.append("order", "desc");
    setListOrder("desc");
    let params = `?page=${1}`;
    setSubCategoriesListId("");
    catgoryList({ payload: formdata, params })
      .unwrap()
      .then((res) => {
        if (res?.status == "success") {
          setClassifiedList(res);
        }
      });
  };

  // CATEGORY LISTS WITH PAGINATE
  const getCategoryListWithPaginate = (id, order) => {
    setSubCategoriesListsId(id);
    setSelectedSubCat("");
    let formdata = new FormData();
    formdata.append("type", 1);
    formdata.append("category_id", id);
    if (order || listOrder !== "") {
      formdata.append("order", order ? order : listOrder);
    } else {
      formdata.append("order", "desc");
      setListOrder("desc");
    }
    let params = `?page=${page}`;
    catgoryList({ payload: formdata, params })
      .unwrap()
      .then((res) => {
        if (res?.status == "success") {
          setClassifiedList(res);
        }
      });
  };

  // SUB CATEGORY LIST
  const getSubcategoriesList = (id) => {
    // console.log("getSubcategoriesList");
    setSubCategoriesListId(id);
    setClassifiedList([]);
    setSubCategoriesListsId("");
    const formData = new FormData();
    if (id) {
      let params = `?page=${1}`;
      formData.append("subcategory_id", id);
      formData.append("order", "desc");
      setListOrder("desc");
      formData.append("type", 1); // CLASSIFIED - 1
      subcategoryListData({ payload: formData, params })
        .unwrap()
        .then((res) => {
          if (res?.status === "success") {
            setClassifiedList(res);
          }
        })
        .catch((err) => {
          console.log("err", err);
        });
    }
  };

  // SUB CATEGORY LIST WITH PAGENATE
  const getSubcategoriesListPaginate = (id, order) => {
    setSubCategoriesListId(id);
    setClassifiedList([]);
    setSubCategoriesListsId("");
    const formData = new FormData();
    if (order || listOrder !== "") {
      formData.append("order", order ? order : listOrder);
    } else {
      formData.append("order", "desc");
      setListOrder("desc");
    }
    if (id) {
      let params = `?page=${page}`;
      formData.append("subcategory_id", id);
      formData.append("type", 1); // CLASSIFIED - 1
      subcategoryListData({ payload: formData, params })
        .unwrap()
        .then((res) => {
          // console.log(res);
          if (res?.status === "success") {
            setClassifiedList(res);
          }
        })
        .catch((err) => {
          console.log("err", err);
        });
    }
  };

  const onSubCategoryClick = (item) => {
    getSubcategoriesList(item?.id);
    setSelectedSubCat(item?.id);
    setCatSubNames(item);
    removeQueryParams();
    setListOrder("");
  };

  useEffect(() => {
    if (location?.state?.subcategory_id) {
      showTabListHandler(location?.state?.subcategory_id);
    } else if (searchParams?.get("catId") && searchParams?.get("subId")) {
      let item = {
        id: searchParams?.get("catId"),
      };
      let data = {
        id: searchParams?.get("catId"),
        name: searchParams?.get("catName"),
      };
      let datas = {
        id: searchParams?.get("subId"),
        name: searchParams?.get("subName"),
      };
      showTabListHandler(item);
      setCatNames(data);
      setCatSubNames(datas);
    } else if (searchParams?.get("catId")) {
      let item = {
        id: searchParams?.get("catId"),
      };
      let data = {
        id: searchParams?.get("catId"),
        name: searchParams?.get("catName"),
      };
      showTabListHandler(item);
      setCatNames(data);
    } else {
      if (subcategoriesListId) {
        getSubcategoriesListPaginate(subcategoriesListId, listOrder);
        console.log("wwwwww");
      } else if (subcategoriesListsId) {
        getCategoryListWithPaginate(subcategoriesListsId, listOrder);
      } else {
        getOverallList(listOrder);
      }
    }
  }, [listOrder, searchParams?.get("catId")]);

  // REMOVE PARAMS
  const removeQueryParams = () => {
    const catId = searchParams.get("catId");
    const subId = searchParams.get("subId");
    const catName = searchParams.get("catName");
    const subName = searchParams.get("subName");

    if (catId) {
      // 👇️ delete each query param
      searchParams.delete("catId");

      // 👇️ update state after
      setSearchParams(searchParams);
    }

    if (subId) {
      searchParams.delete("subId");
      setSearchParams(searchParams);
    }

    if (catName) {
      searchParams.delete("catName");
      setSearchParams(searchParams);
    }

    if (subName) {
      searchParams.delete("subName");
      setSearchParams(searchParams);
    }
  };

  return (
    <div>
      <div className="list-banner pt-md-3 pb-2">
        <img src={classified_banner} alt="" />
      </div>
      <div className="bread-crum-list d-flex ac-je">
        <button
          className="cust-btn d-flex ac-js fs-14 f2"
          onClick={() => navigate("/")}
        >
          <HomeIcon className="fs-16 me-1" />
          Home
        </button>
        <ChevronRightIcon className="fs-20 me-1" />
        <button
          className="cust-btn d-flex ac-js fs-14 f2"
          onClick={() => getOverallList()}
        >
          Classified
        </button>
        {Object.values(catNames)?.length > 0 && (
          <>
            <ChevronRightIcon className="fs-20 me-1" />
            <button
              className="cust-btn d-flex ac-js fs-14 f2"
              onClick={() => {
                setCatSubNames([]);
                removeQueryParams();
                showTabListHandler(catNames);
                setSubCategoriesListId("");
                setPage(1);
                setListOrder("");
              }}
            >
              {catNames?.name}
            </button>
          </>
        )}
        {classifiedList?.classifieds?.length > 0 &&
          Object.values(catSubNames)?.length > 0 && (
            <>
              <ChevronRightIcon className="fs-20 me-1" />
              <button className="cust-btn d-flex ac-js fs-14 f2">
                {catSubNames?.name}
              </button>
            </>
          )}
      </div>
      <ClassifiedTab
        showTabList={showTabList}
        setShowTabList={setShowTabList}
        subCategTabList={subCategTabList}
        showTabListHandler={showTabListHandler}
        setPage={setPage}
        subcategoriesList={subcategoriesList}
        selectedSubCat={selectedSubCat}
        onSubCategoryClick={onSubCategoryClick}
        catNames={catNames}
        setCatNames={setCatNames}
      />
      <ClassifiedListBox
        classifiedList={classifiedList}
        subCategTabList={subCategTabList}
        setPage={setPage}
        page={page}
        listOrder={listOrder}
        setListOrder={setListOrder}
      />
    </div>
  );
};

export default ClassifiedList;
